module.exports = __webpack_public_path__ + "img/Chile.727c4361.svg";